module.exports = __webpack_public_path__ + "img/SZG_TC.3f625113.jpg";